import { Injectable } from '@angular/core';

import { EChannel, ICalType, Listing } from '@hosty-app/types';

import { airbnbApprovalStatus, vrboApprovalStatus } from '@hosty-web/interfaces';

import { ListingMetadata } from '../../../../../libs/types/src/lib/models/listing';

@Injectable({ providedIn: 'root' })
export class ListingStatusService {
  checkActive(listing: Pick<Listing, 'connectVrbo' | 'connectAirbnb'>, channel: EChannel): boolean {
    switch (channel) {
      case EChannel.Vrbo:
        return listing.connectVrbo;
      case EChannel.Airbnb:
        return listing.connectAirbnb;
      case EChannel.Hosty:
        return true;
      default:
        const _: never = channel;
        throw new Error('No such channel ' + channel);
    }
  }

  checkListed(
    listing: Pick<
      Listing,
      'connectVrbo' | 'connectAirbnb' | 'publishVrbo' | 'publishAirbnb' | 'iCal' | 'publishHosty'
    > & { metadata: Pick<ListingMetadata, 'hasWebsite'> },
    channel: EChannel,
  ): boolean | null {
    switch (channel) {
      case EChannel.Vrbo:
        return (
          (listing.connectVrbo && listing.publishVrbo) ||
          listing.iCal?.some((i) => i.type === ICalType.VRBO)
        );
      case EChannel.Airbnb:
        return listing.connectAirbnb && listing.publishAirbnb;
      case EChannel.Hosty:
        return listing.metadata?.hasWebsite ? listing.publishHosty : null;
      default:
        const _: never = channel;
        throw new Error('No such channel ' + channel);
    }
  }

  checkDraft(
    listing: Pick<
      Listing,
      | 'publishAirbnb'
      | 'publishVrbo'
      | 'publishHosty'
      | 'connectAirbnb'
      | 'connectVrbo'
      | 'airbnb'
      | 'vrbo'
      | 'hostyApprovalStatus'
    >,
    channel: EChannel,
  ): boolean {
    switch (channel) {
      case EChannel.Vrbo:
        return (
          !listing.publishVrbo &&
          listing.connectVrbo &&
          listing.vrbo?.approvalStatus !== vrboApprovalStatus.approved
        );
      case EChannel.Airbnb:
        return (
          !listing.publishAirbnb &&
          listing.connectAirbnb &&
          listing.airbnb?.approvalStatus !== airbnbApprovalStatus.approved
        );
      case EChannel.Hosty:
        return listing.publishHosty && listing.hostyApprovalStatus !== 'approved';
      default:
        const _: never = channel;
        throw new Error('No such channel ' + channel);
    }
  }
}
